import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CompanyType } from 'src/app/settings/constants';
import { TranslateService } from '@ngx-translate/core';
import { ReceiversService } from 'src/app/shared/services/receivers.service';

@Component({
  selector: 'app-receivers-list-component',
  templateUrl: './receivers-list-component.html',
  styleUrls: ['./receivers-list-component.scss'],
})
export class ReceiversListComponent implements OnInit {
  @Input() company: CompanyType;

  displayedColumns: string[] = ['name', 'apiKey', 'ip', 'monitoringPort', 'receiverEventPort', 'snifferPort'];
  dataSource: any[];

  show = false;

  constructor(private translateService: TranslateService, private receiversService: ReceiversService) {}

  ngOnInit(): void {
    this.dataSource = this.company.receivers;
  }

  isLast(item: any, array: string | any[]) {
    return array[array.length - 1] === item;
  }

  convertToName(ip: string) {
    const serverLocation = this.receiversService.receiverServers.find((location) => location.ip === ip);

    if (!serverLocation) return '-';

    return serverLocation.name + ' - ' + serverLocation.location;
  }
}
